import React, { useEffect, useState } from "react";
import styles from "./customtoggleStyles.module.css";
import MoonIcon from "../../../media/images/icons/toggle-moon.svg";
import MoonSVG from "../../../media/images/icons/moondark.svg";
import SunIcon from "../../../media/images/icons/toggle-sun.svg";
import { useAppDispatch, useAppSelector } from "../../../hooks/useRedux";
import { setThemeMode } from "../../../redux/features/settingSlice";
import TickIcon from "../../../media/images/icons/tick";
import { useTheme } from "@mui/material";

interface Props {
  status: boolean;
  handleToggle: (status: boolean) => void;

  
}

export default function CustomToggleButton({ handleToggle, status }: Props) {
  const { themeMode } = useAppSelector((state) => state.setting);
  const theme = useTheme();
  const [toggle, setToggle] = useState(status);

  useEffect(()=>{
    setToggle(status)

  },[status])

  return (
    <button
      style={{
        backgroundColor: !toggle ? "#E0E0E0" : "#D99036",
      }}
      className={`${styles.toggle_btn} ${!toggle ? styles.toggled : ""}`}
      onClick={() => handleToggle(toggle)}
    >
      <div className={`${toggle ? styles.thumbLight : styles.thumbDark}`}>
        {/* <img
          className={`${
            toggle ? styles.sunTrackActive : styles.sunTrackInActive
          }`}
          width={14}
          src={MoonSVG}
          alt=""
        /> */}
        {/* <img
          className={`${
            toggle ? styles.moonTrackInActive : styles.moonTrackActive
          }`}
          width={14}
          src={SunIcon}
          alt=""
        /> */}
        {toggle && <TickIcon size={14} color={theme.palette.secondary.main} />}
      </div>

      {/* <img
        className={`${
          toggle ? styles.moonTrackInActive : styles.moonTrackActive
        }`}
        width={14}
        src={MoonIcon}
        alt=""
      />
      <img
        className={`${
          toggle ? styles.sunTrackActive : styles.sunTrackInActive
        }`}
        width={14}
        src={SunIcon}
        alt=""
      /> */}
    </button>
  );
}
